/* eslint-disable react/no-deprecated -- 命令式挂载工具，micro-app 子应用中保持 legacy ReactDOM.render/unmountComponentAtNode 行为，避免并发模式差异 */
import React, { ReactNode, useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'antd';
import './index.scss';
interface ModalProps {
  onClose?: AnyFunc;
  onOk?: AnyFunc;
  visible?: boolean;
  content?: ReactNode;
  title?: ReactNode;
  footer?: ReactNode | null;
  width?: number;
  okButtonProps?: any;
  style?: React.CSSProperties;
  container?: HTMLElement | null;
  zIndex?: number;
}
const CommonModal = (props: ModalProps) => {
  const {
    visible,
    content,
    title,
    footer,
    onOk,
    onClose,
    okButtonProps,
    width,
    style,
    container,
    zIndex,
  } = props;
  const [modalVisible, setModalVisible] = useState(visible);
  const handleClose = () => {
    const el = document.getElementById('commonModal');
    if (el) {
      el.parentElement && el.parentElement.removeChild(el);
    }
    setModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      title={title}
      destroyOnClose={true}
      visible={modalVisible}
      maskClosable={false}
      getContainer={container ? () => container : undefined}
      onCancel={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      onOk={(e) => {
        e.stopPropagation();
        onOk && onOk(handleClose);
      }}
      okButtonProps={okButtonProps}
      className="common-modal"
      footer={footer}
      width={width || 600}
      style={style || {}}
      zIndex={zIndex}
    >
      {content}
    </Modal>
  );
};

export const showModal = (options: ModalProps) => {
  let el = document.getElementById('commonModal');
  if (!el) {
    el = document.createElement('div');
    el.setAttribute('id', 'commonModal');
  }
  const mountContainer = options.container ?? document.body;
  mountContainer.appendChild(el);
  ReactDOM.render(
    <CommonModal
      {...options}
      content={options.content}
      onClose={options.onClose}
      onOk={options.onOk}
      okButtonProps={options.okButtonProps || null}
      visible={true}
      title={options.title}
      footer={options.footer}
      width={options.width}
      container={mountContainer}
      zIndex={options.zIndex}
    />,
    el
  );
};

export const closeModal = () => {
  const el = document.getElementById('commonModal');
  if (el) {
    ReactDOM.unmountComponentAtNode(el);
    el.remove();
  }
};
export default CommonModal;
